// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wfItemOuterDIV {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
}

.wfContent {
    z-index: 1;
    position: relative;
    display:flex;
    flex-direction:column;
    height: 100%;
    width: 100%;
    justify-content: center;
    color: var(--workflow-color);
    font-size:10pt;
    overflow:hidden;
}
    
    .wfContent > span {
        align-self: center;
        white-space: pre-wrap;
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        -webkit-user-select: none;
                user-select: none;
    }

.wfContentGrid {
    display: grid;
    grid-template-columns: 30px 1fr;
}
.wfContentIcon {
    align-self:center;
    padding-left:5px;
    padding-right:5px;
    width:100%;
    height:100%;
}
.wfContentIconWrapper {
    grid-column-start: 1;
    grid-column-end: 1;
    width: 100%;
    height: 100%;
    border: 0px solid black;
    border-radius: 10px 0px 0px 10px;
}
.wfContentText{
    grid-column-start:2;
    grid-column-end:2;
    align-self:center;
    padding-right:5px;
    padding-left:5px;
    overflow:hidden;
}

.more-padding{
    padding-left:10px;
    padding-right:10px;
}
    

.wfBackground {
    background: var(--workflow-module-background);
    color: var(--workflow-module-color);
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 3px 3px 10px 0px rgba(0,0,0,0.16);
}
.wfObsoleteItem {
    position: absolute;
    left: -12px;
    top: -12px;
    height: 24px;
    width: 24px;
    z-index: 2;
    border: 0px solid black;
    border-radius: 12px;
    background: var(--workflow-obsolete-background);
    color: var(--workflow-obsolete-color);
}
.wfRemove {
    border: 0px solid black;
    height: 24px;
    width: 24px;
    position: absolute;
    top: -12px;
    right: -12px;
    border-radius: 12px;
    background: var(--workflow-remove-background);
    color: var(--workflow-remove-color);
    font-size: 16px;
    z-index: 2;
    cursor: pointer;
}

.wfAction {
    border: 0px solid black;
    border-radius: 10px;
}
.wfCondition {
    border: 0px solid black;
    transform: rotate(45deg);
    top: 12px !important;
    left: 12px !important;
    width: 70% !important;
    height: 70% !important;
    font-size: 10pt;
}
.wfStart {
    border: 0px solid var(--workflow-start);
    border-radius: 50%;
    background: var(--workflow-start) !important;
}
.wfEnd {
    border: 0px solid var(--workflow-end);
    border-radius: 50%;
    background: var(--workflow-end) !important;
}

.wfActionColor {
    color: var(--workflow-action-color);
}
/*
.wfConditionColor {
    color: var(--workflow-condition-color);
}*/

.wfStartColor {
    color: var(--workflow-start-color) !important;
}

.wfEndColor {
    color: var(--workflow-end-color) !important;
}
.wfShortDescription {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 12px;
    font-size: 8pt;
    line-height: 1.2;
    text-align: center;
    color: var(--workflow-color);
    opacity: 0.8;
    white-space: normal;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/workflow/workflow.item.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,4BAA4B;IAC5B,cAAc;IACd,eAAe;AACnB;;IAEI;QACI,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;QACX,uBAAuB;QACvB,gBAAgB;QAChB,kBAAkB;QAClB,yBAAiB;gBAAjB,iBAAiB;IACrB;;AAEJ;IACI,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,WAAW;AACf;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,gCAAgC;AACpC;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,6CAA6C;IAC7C,mCAAmC;IACnC,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,6CAA6C;AACjD;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;IAC/C,qCAAqC;AACzC;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,6CAA6C;IAC7C,mCAAmC;IACnC,eAAe;IACf,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,4CAA4C;AAChD;AACA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,mCAAmC;AACvC;AACA;;;EAGE;;AAEF;IACI,6CAA6C;AACjD;;AAEA;IACI,2CAA2C;AAC/C;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;AACrB","sourcesContent":[".wfItemOuterDIV {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    justify-content: center;\n}\n\n.wfContent {\n    z-index: 1;\n    position: relative;\n    display:flex;\n    flex-direction:column;\n    height: 100%;\n    width: 100%;\n    justify-content: center;\n    color: var(--workflow-color);\n    font-size:10pt;\n    overflow:hidden;\n}\n    \n    .wfContent > span {\n        align-self: center;\n        white-space: pre-wrap;\n        width: 100%;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        text-align: center;\n        user-select: none;\n    }\n\n.wfContentGrid {\n    display: grid;\n    grid-template-columns: 30px 1fr;\n}\n.wfContentIcon {\n    align-self:center;\n    padding-left:5px;\n    padding-right:5px;\n    width:100%;\n    height:100%;\n}\n.wfContentIconWrapper {\n    grid-column-start: 1;\n    grid-column-end: 1;\n    width: 100%;\n    height: 100%;\n    border: 0px solid black;\n    border-radius: 10px 0px 0px 10px;\n}\n.wfContentText{\n    grid-column-start:2;\n    grid-column-end:2;\n    align-self:center;\n    padding-right:5px;\n    padding-left:5px;\n    overflow:hidden;\n}\n\n.more-padding{\n    padding-left:10px;\n    padding-right:10px;\n}\n    \n\n.wfBackground {\n    background: var(--workflow-module-background);\n    color: var(--workflow-module-color);\n    z-index: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    box-shadow: 3px 3px 10px 0px rgba(0,0,0,0.16);\n}\n.wfObsoleteItem {\n    position: absolute;\n    left: -12px;\n    top: -12px;\n    height: 24px;\n    width: 24px;\n    z-index: 2;\n    border: 0px solid black;\n    border-radius: 12px;\n    background: var(--workflow-obsolete-background);\n    color: var(--workflow-obsolete-color);\n}\n.wfRemove {\n    border: 0px solid black;\n    height: 24px;\n    width: 24px;\n    position: absolute;\n    top: -12px;\n    right: -12px;\n    border-radius: 12px;\n    background: var(--workflow-remove-background);\n    color: var(--workflow-remove-color);\n    font-size: 16px;\n    z-index: 2;\n    cursor: pointer;\n}\n\n.wfAction {\n    border: 0px solid black;\n    border-radius: 10px;\n}\n.wfCondition {\n    border: 0px solid black;\n    transform: rotate(45deg);\n    top: 12px !important;\n    left: 12px !important;\n    width: 70% !important;\n    height: 70% !important;\n    font-size: 10pt;\n}\n.wfStart {\n    border: 0px solid var(--workflow-start);\n    border-radius: 50%;\n    background: var(--workflow-start) !important;\n}\n.wfEnd {\n    border: 0px solid var(--workflow-end);\n    border-radius: 50%;\n    background: var(--workflow-end) !important;\n}\n\n.wfActionColor {\n    color: var(--workflow-action-color);\n}\n/*\n.wfConditionColor {\n    color: var(--workflow-condition-color);\n}*/\n\n.wfStartColor {\n    color: var(--workflow-start-color) !important;\n}\n\n.wfEndColor {\n    color: var(--workflow-end-color) !important;\n}\n.wfShortDescription {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    margin-top: 12px;\n    font-size: 8pt;\n    line-height: 1.2;\n    text-align: center;\n    color: var(--workflow-color);\n    opacity: 0.8;\n    white-space: normal;\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    pointer-events: none;\n    user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
